import {FieldSchema} from '../types';
import {Dictionary} from 'lodash';
import transform from 'lodash/transform';

export default (schema: FieldSchema[]) =>
    transform(schema, (r, f) => r[f.name] = f, {} as Dictionary<FieldSchema>);
